/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataItemFromJSON, MetaDataItemToJSON, } from './MetaDataItem';
/**
 * Check if a given object implements the MetaData interface.
 */
export function instanceOfMetaData(value) {
    var isInstance = true;
    return isInstance;
}
export function MetaDataFromJSON(json) {
    return MetaDataFromJSONTyped(json, false);
}
export function MetaDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'responseId': !exists(json, 'responseId') ? undefined : json['responseId'],
        'items': !exists(json, 'items') ? undefined : (json['items'].map(MetaDataItemFromJSON))
    };
}
export function MetaDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'responseId': value.responseId,
        'items': value.items === undefined ? undefined : (value.items.map(MetaDataItemToJSON))
    };
}
